export const UPLOAD_DOCUMENT_TRANSLATIONS = {
  TITLE: 'Envoi de documents',
  DROPDOWN_AREA: {
    TITLE: 'Faites glisser ou cliquez pour télécharger vos documents',
    DESCRIPTION_10MO: 'maximum 10 documents, taille maximale du lot : 10 Mo',
    TYPE_HINT:
      'Merci de regrouper dans un même lot uniquement des documents appartenant à une même catégorie "Achat/Vente/Autre"',
    DESCRIPTION_25MO: 'maximum 20 documents, taille maximale du lot : 25 Mo',
  },
  UPLOAD_MOBILE: {
    BUTTON: 'Cliquez pour télécharger vos fichiers',
    DESCRIPTION_10MO: 'maximum 10 documents, taille maximale du lot : 10 Mo',
    DESCRIPTION_25MO: 'maximum 20 documents, taille maximale du lot : 25 Mo',
  },
  FILES_LIST: {
    TOTAL_SINGLE: '1 document est prêt à être envoyé',
    TOTAL_MULTIPLE: '{{AMOUNT}} documents sont prêts à être envoyés',
    REMOVE_ALL: 'Supprimer tout',
    EMPTY: "Aucun document n'est encore téléchargé",
    IMPORTANT_INFORMATION: '⚠️ Information importante :',
    IMPORTANT_INFORMATION_TEXT:
      "L'« Envoi de documents » est un espace de dépôt temporaire qui ne constitue pas une solution d’archivage définitif (GED). Les documents qui y sont déposés sont susceptibles d’être supprimés au bout de 2 ans. Nous vous invitons à en conserver une copie dans votre propre espace de stockage si nécessaire.",
    TOOLTIP_TEXT: {
      COUNT_LIMIT_ERROR_MESSAGE_10:
        "Impossible de télécharger ce document car vous avez plus de 10 documents. Veuillez d'abord envoyer 10 documents pour télécharger les suivants",
      COUNT_LIMIT_ERROR_MESSAGE_20:
        "Impossible de télécharger ce document car vous avez plus de 20 documents. Veuillez d'abord envoyer 20 documents pour télécharger les suivants",
      SIZE_LIMIT_ERROR_MESSAGE_10MO:
        "Impossible de télécharger ce document car la taille de l'envoi dépasse les 10Mo.",
      SIZE_LIMIT_ERROR_MESSAGE_25MO:
        "Impossible de télécharger ce document car la taille de l'envoi dépasse les 25Mo.",
      TYPE_FORBIDDEN_ERROR_MESSAGE:
        "Ce type de document ñ'est pas pris en charge",
      FILE_PATTERN_ERROR_MESSAGE:
        'Le nom d’un fichier ne peut comporter les caractères suivantes : \\ / : * ? " < > |',
      FILE_NAME_REQUIRED_ERROR_MESSAGE:
        'Le nom du fichier ne peut pas être vide',
      FILE_NAME_REPEAT:
        '{{AMOUNT}} fichier porte déjà ce nom, merci d’utiliser un titre différent',
    },
  },
  MESSAGES: {
    ERROR:
      "Il est impossible de télécharger {{FILE_NAME}}, ce type de document n'est pas pris en charge",
    FILE_EXISTS: '{{FILE_NAME}} le document existe',
    REMOVED: "{{FILE_NAME}} Le document a été retiré de l'envoi",
    SUCCESS: 'Vos documents ont été bien envoyés !',
    ERROR_DURING_UPLOAD: 'Erreur inconnue lors du téléchargement',
    UPLOAD_PLEASE_WAIT: "Fichiers en cours d'envoi, merci de patienter",
  },
  MODAL: {
    TITLE: 'Suppression du document',
    TITLE_REMOVE_ALL: 'Suppression des documents',
    TEXT: 'Êtes-vous sûr de vouloir supprimer le document {{FILE_NAME}} ?',
    TEXT_REMOVE_ALL: 'Êtes-vous sûr de vouloir supprimer tous les documents ?',
    CANCEL_BUTTON_TEXT: 'Annuler',
    APPLY_BUTTON_TEXT: 'Oui, supprimer',
  },
  BUTTON_CAPTION: 'Envoyer',
  BUTTON_DOWNLOAD_MORE: 'Plus de résultats',
  DOCUMENTS_HISTORY: {
    TITLE: 'Historique des documents envoyés',
    PLACEHOLDER: 'Rechercher',
    SEARCH_BY_NAME: 'Recherche par nom',
    SEARCH_BY_USER: 'Recherche par utilisateur',
    TABLE_HEADER_CAPTIONS: {
      FILE_NAME: 'Nom du document',
      TYPE: 'Type',
      FILE_SEND_BY: 'Utilisateur',
      DATE: 'Date',
      SIZE: 'Taille',
      MISTAKE: 'Demande d’annulation',
      STATUS: 'Statut',
    },
    DATE_PICKER_PLACEHOLDER: 'Sélectionner une date',
    STATUS_MISTAKE: 'Annulé',
    STATUS_DEFAULT: 'Envoyé',
    CONFIRMATION_MISTAKE:
      'Souhaitez-vous réellement annuler ce document/lot de documents ?',
  },
  PRECOMPTA_EMAIL_TEXT:
    'Votre référent Exco a créé une adresse e-mail dédiée pour faciliter la transmission de vos factures. Vous pouvez l’utiliser à tout moment et transférer vos factures en pièce jointe.',
};
